class BdNav {
  constructor(nav) {
    this.nav = nav;
    this.drawerId = nav.querySelector('.bd-nav__hamburger')?.getAttribute('aria-controls');
    this.drawer = this.drawerId ? document.getElementById(this.drawerId) : null;
    this.panel = this.drawer?.querySelector('.bd-nav__drawer-panel');
    this.l1 = this.drawer?.querySelector('.bd-nav__drawer-l1');
    this.l2s = this.drawer?.querySelectorAll('.bd-nav__drawer-l2');

    this.searchTrigger = nav.querySelector('.bd-nav__search-trigger');
    this.searchModalId = this.searchTrigger?.getAttribute('aria-controls');
    this.searchModal = this.searchModalId ? document.getElementById(this.searchModalId) : null;
    this.searchInput = this.searchModal?.querySelector('.bd-nav__search-input');

    this.#setupDesktop();
    this.#setupMobile();
    this.#setupSearch();
  }

  #setupDesktop() {
    const wraps = this.nav.querySelectorAll('.bd-nav__link-wrap--has-mega');
    wraps.forEach((wrap) => {
      wrap.addEventListener('mouseenter', () => this.#openMega(wrap));
      wrap.addEventListener('mouseleave', () => this.#closeMega(wrap));
    });

    document.addEventListener('click', (e) => {
      if (!this.nav.contains(e.target)) this.#closeAllMegas();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.#closeAllMegas();
    });
  }

  #openMega(wrap) {
    this.#closeAllMegas();
    wrap.classList.add('is-open');
    wrap.querySelector('.bd-nav__link')?.setAttribute('aria-expanded', 'true');
  }

  #closeMega(wrap) {
    wrap.classList.remove('is-open');
    wrap.querySelector('.bd-nav__link')?.setAttribute('aria-expanded', 'false');
  }

  #closeAllMegas() {
    this.nav.querySelectorAll('.bd-nav__link-wrap--has-mega.is-open').forEach((w) => this.#closeMega(w));
  }

  #setupMobile() {
    if (!this.drawer) return;

    this.nav.querySelector('.bd-nav__hamburger')?.addEventListener('click', () => this.#openDrawer());

    this.drawer.querySelectorAll('.bd-nav__drawer-close').forEach((btn) => {
      btn.addEventListener('click', () => this.#closeDrawer());
    });

    this.drawer.querySelector('.bd-nav__drawer-overlay')?.addEventListener('click', () => this.#closeDrawer());

    this.drawer.querySelectorAll('.bd-nav__drawer-item[data-nav-index]').forEach((btn) => {
      btn.addEventListener('click', () => this.#openL2(btn.dataset.navIndex));
    });

    this.drawer.querySelectorAll('.bd-nav__drawer-back').forEach((btn) => {
      btn.addEventListener('click', () => this.#closeL2());
    });
  }

  #openDrawer() {
    this.drawer.classList.add('is-open');
    this.drawer.offsetHeight; // force reflow so transition fires
    this.drawer.classList.add('is-visible');
    this.nav.querySelector('.bd-nav__hamburger')?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  #closeDrawer() {
    this.drawer.classList.remove('is-visible');
    this.nav.querySelector('.bd-nav__hamburger')?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';

    this.panel?.addEventListener('transitionend', () => {
      this.drawer.classList.remove('is-open');
      // Reset L2s without animation (drawer is hidden so no visual jump)
      this.l2s?.forEach((l2) => l2.classList.remove('is-open'));
    }, { once: true });
  }

  #openL2(navIndex) {
    this.drawer.querySelector(`.bd-nav__drawer-l2[data-nav-index="${navIndex}"]`)?.classList.add('is-open');
  }

  #closeL2() {
    this.l2s?.forEach((l2) => l2.classList.remove('is-open'));
  }

  #setupSearch() {
    if (!this.searchTrigger || !this.searchModal) return;

    this.searchTrigger.addEventListener('click', () => this.#openSearch());

    this.searchModal.querySelector('.bd-nav__search-modal-overlay')?.addEventListener('click', () => this.#closeSearch());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.searchModal.classList.contains('is-open')) this.#closeSearch();
    });
  }

  #openSearch() {
    this.searchModal.classList.add('is-open');
    this.searchModal.offsetHeight; // force reflow so transition fires
    this.searchModal.classList.add('is-visible');
    this.searchModal.setAttribute('aria-hidden', 'false');
    this.searchTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    this.searchInput?.focus();
  }

  #closeSearch() {
    this.searchModal.classList.remove('is-visible');
    this.searchModal.setAttribute('aria-hidden', 'true');
    this.searchTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';

    this.searchModal.addEventListener('transitionend', () => {
      this.searchModal.classList.remove('is-open');
    }, { once: true });
  }
}

document.querySelectorAll('.bd-nav').forEach((el) => new BdNav(el));
